
























import _ from 'lodash'
import moment from 'moment'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import CheckOutDialog from '@/components/today/CheckOutDialog.vue'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { ISchedule } from '@/store/modules/views/schedule/states'

@Component({
  components: {
    CheckOutDialog,
  },
})
export default class ScheduleLog extends VueExtendedBaseComponent {
  @Prop({ default: () => ({}) }) public detail!: ISchedule

  private checkoutDialog = false
  private loading = true

  get disabledCheckIn() {
    return this.detail && this.detail.endDate && this.detail.endTime
      ? false
      // ? moment().isAfter(moment(`${this.detail.endDate} ${this.detail.endTime}`))
      : true
  }

  @Action('schedule/putScheduleLogs')
  private putScheduleLogs!: (options) => void

  @Action('userprofile/getUserProfile')
  private getUserProfile!: (options: {}) => void

  private doOpenDialog() {
    this.checkoutDialog = true
  }

  get disabledCheckOut() {
    return false
  }

  private async doCheckIn() {
    this.loading = true
    const data = {
      id: this.detail._id,
      logs: [{ text: 'เข้าทำงาน' }],
      status: 'กำลังทำงาน',
    }
    try {
      await this.putScheduleLogs(data)
      this.updateSnackbar({txt: 'ลงเวลางานสำเร็จ', type: 'success'})
      this.loading = false
      this.getUserProfile({})
      // this.$router.push(`/main/today`)
    } catch (error) {
      this.loading = false
    }
  }
}
